export default {
  'dispatches.menuTitle': 'Dispatches',
  'dispatches.sectionTitle': 'Dispatches',
  'dispatches.title': 'Dispatches',
  'dispatches.tab.all': 'All',
  'dispatches.tab.confirmed': 'Confirmed',
  'dispatches.tab.dispatched': 'Dispatched',
  'dispatches.error.fetchingList.title': 'List of orders',
  'dispatches.error.fetchingList.message': 'Error fetching list of orders',
};
